// The supplier overview's switcher and the Vergleich (docs/suppliers.md, "Auswertungen"). Names, dates, units
// and prices are never parameters (the bundle escapes them); the components put them together.
export default {
  views: {
    suppliers: "Lieferanten",
    comparison: "Vergleich",
  },
  not_set_up: "Die Auswertungen gibt es, sobald die Einkaufspreise Lieferanten zugeordnet sind.",
  kinds: {
    ALL: "Alle",
    MATERIAL: "Materialien",
    MACHINE: "Maschinen",
  },
  comparison: {
    title: "Lieferanten vergleichen",
    subtitle: "Wo Sie Materialien und Maschinen am günstigsten bekommen.",
    // Die Auswahl oben in jeder der zwei Karten.
    supplier: "Lieferant",
    filter: {
      MATERIAL: "Materialien filtern",
      MACHINE: "Maschinen filtern",
    },
    // Was die Zahlen sind: weder Karte noch Zeile können es sagen.
    prices_info:
      "Preise je Einheit abzüglich Rabatt, ohne Staffel und Fracht. Den Preis frei Baustelle für eine Menge zeigt der Einkauf eines Artikels.",
    // Unter dem Lieferanten in seiner Karte: bei wie vielen gemeinsamen Artikeln er der günstigere ist.
    cheaper_count: "Günstiger bei {n} von {total}",
    // Ab drei Karten statt „Günstiger bei“: bei wie vielen gemeinsamen Artikeln er der günstigste ist.
    cheapest_count: "Am günstigsten bei {n} von {total}",
    // Die gestrichelte Karte hinter der letzten: noch ein Lieferant, bis zu sechs.
    add_supplier: "Lieferant hinzufügen",
    is_standard: "Ihr Standard",
    shared_none: {
      MATERIAL: "Kein gemeinsames Material.",
      MACHINE: "Keine gemeinsame Maschine.",
    },
    // Unter einer Karte, was nur dieser Lieferant führt; Name und Zahl setzt die Komponente dahinter.
    only: "Nur bei",
    pick: "Wählen Sie zwei Lieferanten.",
    // In einer hinzugefügten Karte, solange ihr Lieferant fehlt.
    pick_one: "Wählen Sie einen Lieferanten.",
    // Ohne einen Artikel, für den es zwei Lieferanten gibt: nichts, womit die Karten öffnen könnten.
    empty: {
      MATERIAL: "Noch hat kein Material Preise von zwei Lieferanten.",
      MACHINE: "Noch hat keine Maschine Preise von zwei Lieferanten.",
    },
    no_match: "Nichts gefunden.",
    truncated: "Die ersten 1000 – der Filter grenzt weiter ein.",
    per: "je",
    other_currency: "andere Währung",
    // Eine Maschinenzeile je Stunde neben Zeilen je Tag, Woche oder Monat: nicht verglichen.
    other_unit: "andere Einheit",
    // Statt der Karten-Inhalte, wenn der Server das Paar ablehnt.
    refused: {
      archived: "Archivierte Lieferanten lassen sich nicht vergleichen.",
      unknown: "Einen der Lieferanten gibt es nicht mehr.",
      other: "Der Vergleich konnte nicht geladen werden.",
    },
    no_kind: "Der Vergleich braucht das Recht, Einkaufspreise von Maschinen oder Materialien zu sehen.",
  },
  // Materialien / Maschinen vergleichen: zwei Artikel nebeneinander, die Zeilen sind die Lieferanten beider.
  item_comparison: {
    title: {
      MATERIAL: "Materialien vergleichen",
      MACHINE: "Maschinen vergleichen",
    },
    subtitle: {
      MATERIAL: "Zwei Materialien und was sie bei Ihren Lieferanten kosten.",
      MACHINE: "Zwei Maschinen und was sie bei Ihren Lieferanten kosten.",
    },
    pick_label: {
      MATERIAL: "Material",
      MACHINE: "Maschine",
    },
    pick: {
      MATERIAL: "Wählen Sie ein zweites Material.",
      MACHINE: "Wählen Sie eine zweite Maschine.",
    },
    // Unter dem Namen in der Karte; Preis, Währung und Einheit folgen.
    typical: "In der Regel",
    shared_none: "Keine gemeinsamen Lieferanten.",
    // Unter einer Karte, die Lieferanten nur dieses Artikels; Name und Zahl setzt die Komponente dahinter.
    only: "Nur für",
    units_differ: "Verschiedene Einheiten: Preise nicht verglichen.",
  },
}
